/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsTranslateRequest,
    DigitizingserviceMelcoDigitizingModelsTranslateRequestFromJSON,
    DigitizingserviceMelcoDigitizingModelsTranslateRequestToJSON,
    DigitizingserviceMelcoDigitizingModelsTranslateResponse,
    DigitizingserviceMelcoDigitizingModelsTranslateResponseFromJSON,
    DigitizingserviceMelcoDigitizingModelsTranslateResponseToJSON,
    DigitizingserviceMelcoModelsError,
    DigitizingserviceMelcoModelsErrorFromJSON,
    DigitizingserviceMelcoModelsErrorToJSON,
} from '../models';

export interface DigitizingServiceLokaliseApiLokaliseGoogleTranslateRequest {
    digitizingserviceMelcoDigitizingModelsTranslateRequest?: DigitizingserviceMelcoDigitizingModelsTranslateRequest;
}

/**
 * 
 */
export class DigitizingServiceLokaliseApi extends runtime.BaseAPI {

    /**
     */
    async lokaliseGoogleTranslateRaw(requestParameters: DigitizingServiceLokaliseApiLokaliseGoogleTranslateRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsTranslateResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/lokalise/google/translate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsTranslateRequestToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsTranslateRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsTranslateResponseFromJSON(jsonValue));
    }

    /**
     */
    async lokaliseGoogleTranslate(requestParameters: DigitizingServiceLokaliseApiLokaliseGoogleTranslateRequest): Promise<DigitizingserviceMelcoDigitizingModelsTranslateResponse> {
        const response = await this.lokaliseGoogleTranslateRaw(requestParameters);
        return await response.value();
    }

}
